<template>
  <div class="checkout-step-container">
    <div class="shipping__methods">
      <h2>{{ $t('Shipping methods') }}</h2>
      <div class="_loading" v-if="loadingShippingMethods"></div>
      <p class="shipping__methods-hint" v-else-if="!shippingPostcode">{{ $t('Fill in your address to see the available shipping methods.') }}</p>
      <div class="block__holder" v-else-if="shippingMethods.length">
        <ValidationProvider class="shipping__methods-list" v-slot="{ errors, classes }" rules="required" tag="ul" :name="$t('Shipping method')">
          <input type="hidden" v-model="selectedShippingMethod"/>
          <checkout-shipping-methods-default v-for="method in shippingMethods" :key="method['carrier_code']" :shipping-method="method" :selected-shipping-method="selectedShippingMethod"></checkout-shipping-methods-default>
          <span class="field-error" v-if="errors.length">{{ $t(errors[0]) }}</span>
        </ValidationProvider>
        <checkout-shipping-postnl-delivery-options></checkout-shipping-postnl-delivery-options>
      </div>
      <div class="_loading" v-else></div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';
  import {ValidationProvider, extend} from 'vee-validate';
  import {required} from 'vee-validate/dist/rules';

  extend('required', required);

  @Component({
    name: 'checkout-shipping-detail',
    components: {
      'checkout-shipping-methods-default': ServiceContainer().getComponent('checkout-shipping-methods-default'),
      'checkout-shipping-postnl-delivery-options': ServiceContainer().getComponent('checkout-shipping-postnl-delivery-options'),
      ValidationProvider
    }
  })

  export default class extends Vue {
    private get loadingShippingMethods(): boolean {
      return this.$store.getters['CheckoutShipping/loadingShippingMethods'];
    }

    private get shippingMethods(): Array<object> {
      return this.$store.getters['CheckoutShipping/shippingMethods'];
    }

    private get selectedShippingMethod(): object | string {
      return Object.keys((this.$store.state.CheckoutShipping.shippingMethod || {})).length > 0 ? this.$store.state.CheckoutShipping.shippingMethod : '';
    }

    private collectTimeout: number | null = null;

    private get shippingPostcode(): string {
      const [, shippingAddress] = this.$store.getters['CheckoutAddress/getAddressData'] || [];
      return shippingAddress?.postcode || '';
    }

    // Address and shipping share one step, so the rates have to follow along
    // while the customer is still typing or picks another address.
    private get shippingDestination(): string {
      const [, shippingAddress] = this.$store.getters['CheckoutAddress/getAddressData'] || [];
      return [
        shippingAddress?.postcode || '',
        shippingAddress?.country_id || '',
        shippingAddress?.city || '',
        (shippingAddress?.street || []).join(' '),
      ].join('|');
    }

    @Watch('shippingDestination', { immediate: true })
    private onShippingDestination(): void {
      if (!this.shippingPostcode) {
        this.$store.dispatch('CheckoutShipping/resetForAddressChange');
        return;
      }

      if (this.collectTimeout) {
        window.clearTimeout(this.collectTimeout);
      }

      this.$store.commit('CheckoutShipping/SET_LOADING_SHIPPING_METHODS', true);

      this.collectTimeout = window.setTimeout(() => {
        this.$store.dispatch('CheckoutShipping/collectShippingMethods');
      }, 600);
    }

    private beforeDestroy(): void {
      if (this.collectTimeout) {
        window.clearTimeout(this.collectTimeout);
      }
    }

  }
</script>
